import List from "./List";
import Show from "./Show";

const events = {
  list: List,
  show: Show,
};

export default events;
